import { Theme } from '@mui/material';

export const styles = {
  root: {
    padding: '20px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflowY: 'auto',
  },
  list: {
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: 0,
      height: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '10px',
    },
  },
  item: {
    borderRadius: '16px',
    maxWidth: '270px',
    overflow: 'hidden',
    height: '100%',
    padding: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  button: (theme: Theme) => ({
    height: 'unset',
    minWidth: 'unset',
    padding: 0,
    '& span, p': {
      transition: 'all 0.3s ease-in-out',
    },
    '&:hover': {
      '& span, p': {
        color: theme.palette.common.brand,
      },
    },
  }),
  button2: (theme: Theme) => ({
    height: 'unset',
    minWidth: 'unset',
    padding: '7.5px 2.5px',
    '& span, p': {
      transition: 'all 0.3s ease-in-out',
    },
    '&:hover': {
      '& span, p': {
        color: theme.palette.text.secondary,
      },
    },
  }),
  createButton: (theme: Theme) => ({
    position: 'relative',
    width: '66px',
    height: '66px',
    background: 'none',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '16px',
    overflow: 'hidden',
  }),
  active: (theme: Theme) => ({
    '& span, p': {
      color: theme.palette.text.disabled,
    },
  }),
  month: (theme: Theme) => ({
    px: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '40px',
    overflowX: 'scroll',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&': {
      [theme.breakpoints.down('md')]: {
        overflowX: 'visible',
        flexDirection: 'column',
        gap: '16px',
        pb: '20px',
      },
    },
  }),
};
